module.exports = __webpack_public_path__ + "static/media/ic_upload.39e5e411.svg";